"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

var _Chips = require('web/components/Chips'); var _Chips2 = _interopRequireDefault(_Chips);
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);
var _Spinner = require('web/components/Spinner');
var _RecipientTable = require('web/screens/Broadcast/RecipientTable');
var _Header = require('web/screens/Directory/Sidebar/Header'); var _Header2 = _interopRequireDefault(_Header);
var _List = require('web/screens/Directory/Sidebar/List');

var _Table = require('./Table'); var _Table2 = _interopRequireDefault(_Table);
var _Toolbar = require('./Toolbar'); var _Toolbar2 = _interopRequireDefault(_Toolbar);
var _SelectionBar = require('./SelectionBar'); var _SelectionBar2 = _interopRequireDefault(_SelectionBar);
var _PatientDrawer = require('./PatientDrawer'); var _PatientDrawer2 = _interopRequireDefault(_PatientDrawer);
var _PatientActions = require('./PatientActions'); var _PatientActions2 = _interopRequireDefault(_PatientActions);
var _ArchiveProgress = require('./ArchiveProgress'); var _ArchiveProgress2 = _interopRequireDefault(_ArchiveProgress);
var _usePatientsTabImport = require('./ImportPatients/usePatientsTabImport');
var _usePatientTable = require('./usePatientTable');
var _useRunningArchives = require('./useRunningArchives');


var _format = require('./format');











// Clicks here keep the side panel open: the panel itself, the dialogs and
// menus it opens, and the table rows, which open, switch or close it
// themselves. A click in a row's checkbox cell ticks it and closes the panel
// (D-50).
const KEEPS_PANEL_OPEN = _PatientDrawer.DRAWER_KEEPS_OPEN
const keepsPanelOpen = (target) => {
  if (!(target instanceof Element) || !target.isConnected) return true
  if (target.closest(KEEPS_PANEL_OPEN)) return true
  return !!target.closest('.dir-table-page .campaign--table--row') && !target.closest('.campaign--table--row-checkbox')
}

const TEXT_FIELDS = 'input:not([type="checkbox"]):not([type="radio"]), textarea, select'

const HIDDEN_COLUMNS_KEY = 'directory.patientTable.hiddenColumns'

// The Columns menu's choice is remembered in this browser (cover sheet
// assumption).
const readHiddenColumns = () => {
  try {
    const raw = window.localStorage.getItem(HIDDEN_COLUMNS_KEY)
    // SAFETY: written by this module as an array of column ids; unknown ids are ignored.
    return new Set(raw ? JSON.parse(raw)  : [])
  } catch (e2) {
    return new Set()
  }
}

/* The Directory's Patients tab on web and desktop (D-7, D-8): every patient
 * of the org in one compact table, across the full width, with the Directory
 * header and tabs above it (patients-v3-default). Coworkers and Teams keep
 * their sidebar lists (D-4). */
const PatientTablePage = ({
  orgKey, selectedTab, onSelectTab, openPatientKey, onRequestPatientsFeature, onStartChat,
}) => {
  // A page waits for its running-archive marks before it shows (D-61).
  const beforeShow = _react.useRef(null)
  const onBeforeShow = _react.useCallback.call(void 0, (keys) => _nullishCoalesce(_optionalChain([beforeShow, 'access', _ => _.current, 'optionalCall', _2 => _2(keys)]), () => ( Promise.resolve())), [])
  const table = _usePatientTable.usePatientTable.call(void 0, orgKey, onBeforeShow)
  const isAdmin = _hooks.useAppSelector.call(void 0, state => _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const [tags, setTags] = _react.useState([])
  const [hiddenColumns, setHiddenColumns] = _react.useState(readHiddenColumns)
  const [action, setAction] = _react.useState(null)

  const loadTags = _react.useCallback.call(void 0, 
    () => _actions2.default.listPatientTags({ OrgKey: orgKey }).then(r => setTags(r.Tags)).catch(() => undefined),
    [orgKey],
  )
  _react.useEffect.call(void 0, () => { loadTags() }, [loadTags])

  const onToggleColumn = _react.useCallback.call(void 0, (column) => {
    const next = new Set(hiddenColumns)
    if (next.has(column)) next.delete(column)
    else next.add(column)
    setHiddenColumns(next)
    try {
      window.localStorage.setItem(HIDDEN_COLUMNS_KEY, JSON.stringify([...next]))
    } catch (e3) {
      // Remembering is a convenience; the menu still works for this visit.
    }
  }, [hiddenColumns])

  const {
    view, rows, total, selectedCount, fullFilter, query, hasSelection,
  } = table
  const isArchivedView = view === 'archived'
  const description = _format.describeFilter.call(void 0, fullFilter, tags)
  const isFiltered = !!query || _format.hasFilters.call(void 0, fullFilter)

  const { isSelected, clearSelection } = table
  // The header checkbox ticks the page; its menu goes on to everyone
  // matching, or clears (D-84).
  const selectMenu = _react.useMemo.call(void 0, () => ({
    pageCount: table.selectableCount,
    matchingCount: table.matchingCount,
    onPage: table.selectPage,
    onAll: table.selectAllMatching,
    onClear: table.clearSelection,
  }), [table.selectableCount, table.matchingCount, table.selectPage, table.selectAllMatching, table.clearSelection])

  // Escape clears the selection (D-52). A dialog, menu or text field keeps its
  // own Escape, and an open panel closes first.
  _react.useEffect.call(void 0, () => {
    if (!hasSelection || openPatientKey) return
    const onKey = (e) => {
      if (e.key !== 'Escape' || e.defaultPrevented || document.querySelector('.blm-modal')) return
      // A ticked row's checkbox keeps focus; text fields keep their Escape.
      const focus = document.activeElement
      if (focus instanceof HTMLElement && (focus.isContentEditable
        || focus.matches(TEXT_FIELDS) || focus.closest('[role="dialog"], [role="menu"], [role="listbox"]'))) return
      clearSelection()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [hasSelection, openPatientKey, clearSelection])

  const emptyState = _react.useMemo.call(void 0, () => {
    if (table.hasError) return _react2.default.createElement('span', { className: "recipients-screen--no-match", __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}, "No patients to show."   )
    if (!table.hasLoaded || (table.isLoading && rows.length === 0)) {
      return _react2.default.createElement(_Spinner.SimpleSpinner, { className: "campaign--table--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}} )
    }
    if (isFiltered) {
      const scope = isArchivedView ? 'archived' : 'active'
      return (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('span', { className: "recipients-screen--no-match", __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}
            ,  query ? `No ${scope} patients match \u201C${query}\u201D.` : `No ${scope} patients match these filters.` 
          )
          ,  !isArchivedView && (
            _react2.default.createElement('button', { type: "button", className: "dir-link", onClick: () => table.setView('archived'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}, "Search archived patients"  )
          )
        )
      )
    }
    if (isArchivedView) return _react2.default.createElement('span', { className: "recipients-screen--no-match", __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}, "No archived patients."  )
    return (
      _react2.default.createElement('div', { className: "recipients-empty--inner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}
        , _react2.default.createElement('div', { className: "recipients-empty--icon", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}}
          , _react2.default.createElement('img', { src: "/assets/icons/add-participant-black.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}} )
        )
        , _react2.default.createElement('div', { className: "recipients-empty--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}, "No patients yet"  )
        , _react2.default.createElement('div', { className: "recipients-empty--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}, "Add a patient with the + button. Patients who text your BloomText numbers appear here too."

        )
        , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--primary dir-empty--btn"  , onClick: () => setAction({ kind: 'create' }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 165}}, "Add a patient"

        )
      )
    )
  }, [table, rows.length, isFiltered, isArchivedView, query])

  const isEmptyOrg = table.hasLoaded && !table.hasError && !isFiltered && !isArchivedView && total === 0
  const first = table.page * _format.PAGE_SIZE + 1
  const last = table.page * _format.PAGE_SIZE + rows.length

  // The side panel reads its own row, so it keeps its real tags, dates and
  // archive state whatever page, view or filter the table shows (review F-3),
  // and re-reads it as soon as an action finishes. The open page's row stands
  // in while it loads.
  const pageRow = _nullishCoalesce(rows.find(r => r.PatientKey === openPatientKey), () => ( null))
  const [fetchedRow, setFetchedRow] = _react.useState(null)
  const [rowReloads, setRowReloads] = _react.useState.call(void 0, 0)
  _react.useEffect.call(void 0, () => {
    if (!openPatientKey) return
    let isCurrent = true
    _actions2.default.getPatientTableRow({ OrgKey: orgKey, PatientKey: openPatientKey })
      .then(r => { if (isCurrent) setFetchedRow(r.Patient) })
      .catch(() => undefined)
    return () => { isCurrent = false }
  }, [orgKey, openPatientKey, rows, rowReloads])
  const openRow = _nullishCoalesce((_optionalChain([fetchedRow, 'optionalAccess', _3 => _3.PatientKey]) === openPatientKey ? fetchedRow : null), () => ( pageRow))

  const onClosePanel = _react.useCallback.call(void 0, () => _actions2.default.gotoDirectory(), [])
  // A row opens its patient, switches the panel to them, or, when theirs is
  // open, closes it (D-50).
  const onOpen = _react.useCallback.call(void 0, (row) => row.PatientKey === openPatientKey
    ? _actions2.default.gotoDirectory()
    : _actions2.default.gotoPatientPage(orgKey, row.PatientKey), [orgKey, openPatientKey])
  _react.useEffect.call(void 0, () => {
    if (!openPatientKey) return
    // Capture: the checkbox cell stops its click before it bubbles here.
    const onClick = (e) => { if (!keepsPanelOpen(e.target)) onClosePanel() }
    document.addEventListener('click', onClick, true)
    return () => document.removeEventListener('click', onClick, true)
  }, [openPatientKey, onClosePanel])

  const onDone = _react.useCallback.call(void 0, () => {
    table.clearSelection()
    table.reload()
    setRowReloads(n => n + 1)
    loadTags()
  }, [table, loadTags])

  // Running archives and restores, this user's or anyone's (D-61): their
  // rows wait with a pill, the page reloads as each chunk finishes, and each
  // ends with its notice. Only one this page started clears the selection.
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const rowKeys = _react.useMemo.call(void 0, () => rows.map(r => r.PatientKey), [rows])
  const onArchiveProgress = _react.useCallback.call(void 0, () => {
    table.reload()
    setRowReloads(n => n + 1)
  }, [table])
  const onArchiveFinished = _react.useCallback((task, status, started) => {
    const notice = _useRunningArchives.finishedNotice.call(void 0, task.Restore, task.Total, status)
    if (notice.isWarning) showWarningBar(notice.text)
    else showSuccessBar(notice.text)
    if (_optionalChain([started, 'optionalAccess', _4 => _4.closesPanel])) onClosePanel()
    if (started) onDone()
    else onArchiveProgress()
  }, [showSuccessBar, showWarningBar, onClosePanel, onDone, onArchiveProgress])
  const running = _useRunningArchives.useRunningArchives.call(void 0, { orgKey, rowKeys, onProgress: onArchiveProgress, onFinished: onArchiveFinished })
  const { setLocked } = table
  _react.useEffect.call(void 0, () => { setLocked(new Set(running.pending.keys())) }, [running.pending, setLocked])
  _react.useEffect.call(void 0, () => { beforeShow.current = running.prepare }, [running.prepare])
  const { track } = running
  const onArchiveStarted = _react.useCallback((key, task) => {
    table.clearSelection()
    track(key, task)
  }, [table, track])

  // D-97, D-98: admins import a CSV of patients; its progress, then its
  // result, show in the archive bar's place, for any admin on the tab.
  const onImportFinished = _react.useCallback.call(void 0, () => {
    table.reload()
    setRowReloads(n => n + 1)
    loadTags()
  }, [table, loadTags])
  const patientImport = _usePatientsTabImport.usePatientsTabImport.call(void 0, {
    orgKey, isAdmin, tags, onTagsChanged: loadTags, onFinished: onImportFinished,
    onShowTag: tagKey => {
      table.setView('active')
      table.setFilter({ TagKeys: [tagKey] })
    },
  })

  return (
    _react2.default.createElement('div', { className: "dir-table-page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}
      , _react2.default.createElement('div', { className: "dir-table-page--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 258}}
        , _react2.default.createElement(_Header2.default, {
          orgKey: orgKey,
          selectedTab: selectedTab,
          onRequestPatientsFeature: onRequestPatientsFeature,
          beforeAdd: patientImport.button, __self: this, __source: {fileName: _jsxFileName, lineNumber: 259}}
        )
        , _react2.default.createElement('div', { className: "inbox-tabs inbox-tabs--even" , role: "group", 'aria-label': "Show", __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}
          , _react2.default.createElement(_Chips2.default, {
            pills: _List.directoryTabOptions,
            activeTab: selectedTab,
            onSelectTab: onSelectTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}
          )
        )
      )
      , _react2.default.createElement('div', { className: "dir-table-page--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 273}}
        ,  hasSelection
          ? (
              _react2.default.createElement(_SelectionBar2.default, {
                view: view,
                summary: table.summary,
                isAdmin: isAdmin,
                isBusy: !!_optionalChain([action, 'optionalAccess', _5 => _5.isBusy]),
                isWaiting: !table.isLeftOutConfirmed,
                hasCountFailed: table.hasPreviewFailed,
                onRetryCount: table.retryPreview,
                onClear: table.clearSelection,
                onSelectAll: table.selectAllMatching,
                onTag: () => {
                  loadTags()
                  setAction({ kind: 'tag' })
                },
                onBroadcast: () => setAction({ kind: 'broadcast' }),
                onArchive: () => setAction({ kind: 'archive' }),
                onRestore: () => setAction({ kind: 'restore' }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}}
              )
            )
          : (
              _react2.default.createElement(_Toolbar2.default, {
                view: view,
                onView: table.setView,
                activeCount: table.activeCount,
                archivedCount: table.archivedCount,
                search: table.search,
                onSearch: table.setSearch,
                filter: table.filter,
                onFilter: table.setFilter,
                tags: tags,
                hiddenColumns: hiddenColumns,
                onToggleColumn: onToggleColumn,
                hasCounts: table.hasLoaded,
                onOpenFilters: loadTags,
                hasPatientApp: table.hasPatientApp, __self: this, __source: {fileName: _jsxFileName, lineNumber: 296}}
              )
            )
        ,  table.hasError && (
          _react2.default.createElement(_WarningBar2.default, { theme: "warning", className: "dir-warning", linkText: "Try again" , onLinkClick: table.reload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 314}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 315}}, "Patients couldn't load."  ), " Check your connection; nothing was changed."
          )
        )
        , _react2.default.createElement(_ArchiveProgress2.default, { archives: running.archives, __self: this, __source: {fileName: _jsxFileName, lineNumber: 318}} )
        ,  patientImport.bar 
        , _react2.default.createElement(_Table2.default, {
          view: view,
          hiddenColumns: hiddenColumns,
          rows: rows,
          sort: table.sort,
          onSort: table.onSort,
          isSelected: isSelected,
          onToggle: table.toggle,
          allSelection: table.headerState,
          onSelectAll: table.pressHeader,
          selectMenu: selectMenu,
          openPatientKey: openPatientKey,
          onOpen: onOpen,
          emptyState: emptyState,
          emptyClassName: isEmptyOrg ? 'recipients-empty' : undefined,
          isBusy: table.isLoading,
          pending: running.pending, __self: this, __source: {fileName: _jsxFileName, lineNumber: 320}}
        )
        ,  table.hasLoaded && !table.hasError && !isEmptyOrg && (
          _react2.default.createElement('div', { className: "dir-footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 339}}
            , _react2.default.createElement('span', { className: "dir-footer--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 340}}
              ,  total > 0
                ? _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 342}},  _format.formatCount.call(void 0, first) , "–",  _format.formatCount.call(void 0, last) ), " of "  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 342}},  _format.formatCount.call(void 0, total) ), " " ,  _format.patientsNoun.call(void 0, total, isArchivedView, description) )
                // The view's count follows the search and filters (D-62), so no matches reads as none of them.
                : _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 344}}, "0"), " " ,  _format.patientsNoun.call(void 0, 0, isArchivedView, description) )
              
            )
            , _react2.default.createElement(_RecipientTable.RecipientPager, { page: table.page, pageCount: Math.ceil(total / _format.PAGE_SIZE), onPage: table.setPage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 347}} )
          )
        )
      )
      ,  openPatientKey && (
        _react2.default.createElement(_PatientDrawer2.default, {
          key: openPatientKey,
          orgKey: orgKey,
          patientKey: openPatientKey,
          row: openRow,
          isAdmin: isAdmin,
          pendingKind: running.pending.get(openPatientKey),
          onClose: onClosePanel,
          onAction: a => {
            if (a.kind === 'tag') loadTags()
            setAction(a)
          },
          onRemoveTag: tag => setAction({ kind: 'untag', patientKeys: [openPatientKey], tag, isArchived: !!_optionalChain([openRow, 'optionalAccess', _6 => _6.Archived]) }),
          onRequestPatientsFeature: onRequestPatientsFeature,
          onStartChat: onStartChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 352}}
        )
      )
      ,  patientImport.dialog 
      , _react2.default.createElement(_PatientActions2.default, {
        orgKey: orgKey,
        action: action,
        onAction: setAction,
        onDone: onDone,
        selection: table.selectionRequest,
        selectedCount: selectedCount,
        description: description,
        tags: tags,
        isArchivedView: isArchivedView,
        onArchiveStarted: onArchiveStarted, __self: this, __source: {fileName: _jsxFileName, lineNumber: 370}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, PatientTablePage)
